// ThriveSignaturePDF.jsx
import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Link
} from '@react-pdf/renderer';

// Translated styles (based on your HTML/CSS)
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
    backgroundColor: '#ffffff',
  },
  previewContainer: {
    border: '1px solid #ddd',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  header: {
    backgroundColor: '#f1f4ff',
    padding: 20,
    textAlign: 'center',
    marginBottom: 30,
    position: 'relative',
  },
  date: {
    position: 'absolute',
    top: 10,
    right: 20,
    fontSize: 10,
    color: '#555',
  },
  title: {
    fontSize: 18,
    color: '#222',
    marginTop: 20,
  },
  body: {
    paddingHorizontal: 20,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    borderBottomStyle: 'solid',
  },
  label: {
    width: '40%',
    fontWeight: 'bold',
    color: '#333',
  },
  value: {
    width: '60%',
    color: '#444',
  },
  tag: {
    backgroundColor: '#e0e7ff',
    color: '#1a237e',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 6,
    fontWeight: 'bold',
  },
  agreementSection: {
    fontSize: 10,
    color: '#333',
    lineHeight: 1.5,
    marginTop: 40,
  },
  signatureLabel: {
    marginTop: 20,
    fontWeight: 'bold',
  },
  signatureImage: {
    marginTop: 10,
    width: 200,
    height: 60,
  },
});

const ThriveSignaturePDF = ({ formData = {}, formFields = [] }) => {
    console.log(formData?.signature,"formData")
  const foundDate = formData.created_at || formData.createdAt;
  const formattedDate = foundDate
    ? new Date(foundDate).toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
    : '-';

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.previewContainer}>
          <View style={styles.header}>
            <Text style={styles.date}>Submitted Date: {formattedDate}</Text>
            <Text style={styles.title}>Henry Schein Thrive Signature Enrollment Form</Text>
          </View>

          <View style={styles.body}>
            {formFields.map((field) => {
              const isTag = ['title', 'subscription_plan', 'state'].includes(field.key);
              const value = formData[field.key] || '-';

              return (
                <View style={styles.row} key={field.key}>
                  <Text style={styles.label}>{field.label}</Text>
                  <Text style={[styles.value, isTag && styles.tag]}>{value}</Text>
                </View>
              );
            })}

            <View style={styles.agreementSection}>
              <Text>
                By clicking the "Enroll" button below, you agree: (i) to place this order and agree to the related terms electronically, and (ii) to the terms and conditions of the{' '}
                <Link src={formData?.thrivesignatureLink}>Thrive Signature Service Agreement</Link>.
              </Text>
              <Text>
                Placing this order also includes your acceptance and agreement to our program{' '}
                <Link src={formData?.thrivesignaturetermconditionLink}>Terms and Conditions</Link>. Please read them before placing this order.
              </Text>

              <Text style={styles.signatureLabel}>Signature:</Text>
              {formData.signaturebase64 && <Image style={styles.signatureImage} src={formData.signaturebase64} />}
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default ThriveSignaturePDF;
